export type VehicleDetails = {
	brandCode?: BrandCode;
	modelName?: string;
	modelYear?: string;
	fuelType?: FuelType;
	imageUrl?: string;
};
export enum BrandCode {
	'TOY' = `TOYOTA`,
	'LEX' = `LEXUS`
}

export enum FuelType {
	'E' = `ELECTRIC`,
	'G' = `PETROL`,
	'R' = `HYDROGEN`,
	'D' = `DIESEL`,
	'B' = `HYBRID`,
	'Y' = `HYBRID`,
	'I' = `PLUGIN HYBRID`
}

export const TERM_UNIT = {
	YEARS: `YRS`,
	MONTHS: `MTH`,
	DAYS: `DAY`
};

type SubscriptionsInfoProductSubscription = {
	productType?: string;
	status?: string;
	subscriptionStartDate?: string;
	subscriptionEndDate?: string;
};

type SubscriptionsInfoProduct = {
	productCode?: string;
	productName?: string;
	productDescription?: string;
	productImageUrl?: string;
	productTerm?: string;
	productTermUnit?: string;
	subscription?: SubscriptionsInfoProductSubscription;
};

type SubscriptionsInfo = {
	product?: SubscriptionsInfoProduct;
};

type ExternalSubscriptionsInfoProductSubscription = {
	status?: string;
	subscriptionStartDate?: string;
};

type ExternalSubscriptionsInfoProduct = {
	productCode?: string;
	productImageUrl?: string;
	redirectURL?: string;
	subscription?: ExternalSubscriptionsInfoProductSubscription;
};

type ExternalSubscriptionsInfo = {
	product?: ExternalSubscriptionsInfoProduct;
};

export type SubscriptionResponse = {
	vin?: string;
	subscriptionsInfo?: SubscriptionsInfo[];
	externalSubscriptionsInfo?: ExternalSubscriptionsInfo[];
};

export type ExtendedCapability = {
	[key: string]: boolean;
};

export type FeaturesAndCapabilitiesResponsePayloadServiceCategoryExt = {
	categoryName?: string;
	extendedCapability?: ExtendedCapability;
};

export type FeaturesAndCapabilitiesResponsePayloadServiceCategorySubObject = {
	subCategoryName?: string;
	extendedCapability?: ExtendedCapability;
};

export type FeaturesAndCapabilitiesResponsePayloadServiceCategorySub = {
	categoryName?: string;
	subCategory?: FeaturesAndCapabilitiesResponsePayloadServiceCategorySubObject[];
};

export type FeaturesAndCapabilitiesResponsePayloadService = {
	serviceName: string;
	category?: (
		| FeaturesAndCapabilitiesResponsePayloadServiceCategoryExt
		| FeaturesAndCapabilitiesResponsePayloadServiceCategorySub
	)[];
	productType: string;
	term?: string;
	termUnit?:
		| typeof TERM_UNIT.DAYS
		| typeof TERM_UNIT.MONTHS
		| typeof TERM_UNIT.YEARS;
};

export type getVehicleDataResponse = {
	vehicleDetails?: VehicleDetails;
	services?: FeaturesAndCapabilitiesResponsePayloadService[];
};

export type VehicleFeatures = {
	status?: number;
	payload?: getVehicleDataResponse;
};
